export enum EErrorStatus {
    BAD_REQUEST = 'BAD_REQUEST',
    UNAUTHORIZED = 'UNAUTHORIZED',
    LOCKED = 'LOCKED',
    NOT_FOUND = 'NOT_FOUND',
    FORBIDDEN = 'FORBIDDEN',
    PRECONDITION_FAILED = 'PRECONDITION_FAILED',
    DESTINATION_LOCKED = 'DESTINATION_LOCKED'
}